module.exports = __webpack_public_path__ + "img/loading.73fad851.svg";